/**
 * WhatsApp Sessions Component
 * 
 * This component displays a list of active WhatsApp conversation sessions
 * with their current step and last activity.
 */

import React from 'react';
import { useApp } from '../../context/AppContext';
import { useTranslations } from '../../context/TranslationsContext';

const WhatsAppSessions = ({ sessions, onSessionSelect }) => {
  const { translations } = useTranslations();
  const { state } = useApp();
  const t = translations[state.currentLanguage];

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString(state.currentLanguage === 'ar' ? 'ar-SA' : 'en-US');
  };

  const getStepName = (step) => {
    const stepNames = {
      welcome: 'مرحباً',
      personal_info_name: 'معلومات شخصية - الاسم',
      personal_info_id: 'معلومات شخصية - الهوية',
      personal_info_address: 'معلومات شخصية - العنوان',
      storage_items: 'تفاصيل التخزين - المحتويات',
      storage_space: 'تفاصيل التخزين - المساحة',
      storage_duration: 'تفاصيل التخزين - المدة',
      additional_services: 'الخدمات الإضافية',
      images: 'الصور',
      confirmation: 'التأكيد',
      completed: 'مكتمل'
    };
    return stepNames[step] || step;
  };

  return (
    <div className="whatsapp-sessions">
      <h3>{t.whatsappSessions}</h3>
      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>{t.phoneNumber}</th>
              <th>{t.currentStep}</th>
              <th>{t.lastUpdate}</th>
              <th>{t.creationDate}</th>
              {onSessionSelect && <th>{t.actions}</th>}
            </tr>
          </thead>
          <tbody>
            {sessions.map(session => (
              <tr 
                key={session.session_id}
                className="session-row"
                onClick={() => onSessionSelect && onSessionSelect(session.session_id)}
                style={{ cursor: onSessionSelect ? 'pointer' : 'default' }}
              >
                <td>{session.phone_number}</td>
                <td>
                  <span className="step-badge">
                    {getStepName(session.step)}
                  </span>
                </td>
                <td>{formatDate(session.last_updated)}</td>
                <td>{formatDate(session.created_at)}</td>
                {onSessionSelect && (
                  <td>
                    <button className="view-conversation-btn">
                      {t.viewConversation}
                    </button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WhatsAppSessions;
